import { type QuestionData } from '../support.type';
import { Question } from './Question';

export class LinkQuestion extends Question {
    constructor(
        question: QuestionData,
        public readonly link: string
    ) {
        super(question);
    }
}
